<template>
  <div>
    <div align="left"></div>
    <br />
    <div class="text-left">
      <h5 class="font-weight-bold text-primary">About Us</h5>
      <b-row class="mt-4">
        <b-col md="4" class="my-1">
          <b-form-group class="mb-0">
            <b-input-group>
              <b-form-input v-model="filter" placeholder="Search"></b-form-input>
              <b-input-group-append>
                <b-button variant="primary" :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>
        </b-col>
        <b-col md="2" class="my-1" align="right">
          <b-form-group label-cols-sm="6" label="Show" class="mb-0">
            <b-form-select v-model="perPage" :options="pageOptions"></b-form-select>
          </b-form-group>
        </b-col>
        <b-col md="3" class="my-1"></b-col>
        <b-col md="3" class="my-1" align="right">
          <router-link :to="{name: 'createAboutus'}">
            <b-button variant="primary">
              <img src="@/assets/create-new.svg" class="mr-2" alt />Create New
            </b-button>
          </router-link>
        </b-col>
      </b-row>
      <b-row>
        <br />
      </b-row>
      <section v-if="errored">
        <p>We're sorry, we're not able to retrieve this information at the moment, please try back later</p>
      </section>
      <!-- Main table element -->
      <b-table
        v-else
        responsive
        show-empty
        hover
        :busy="loading"
        :items="items"
        :fields="key"
        :current-page="currentPage"
        :per-page="perPage"
        :filter="filter"
        :sort-by.sync="sortBy"
        :sort-desc.sync="sortDesc"
        :sort-direction="sortDirection"
        @filtered="onFiltered"
        head-variant="light"
        class="bg-white"
      >
        <div slot="table-busy" class="text-center text-primary my-2">
          <b-spinner class="align-middle"></b-spinner>
          <strong>Loading...</strong>
        </div>
        <template v-slot:cell(content.id)="row">
          <div v-html="row.value.substring(0,50)"></div>
        </template>
        <template v-slot:cell(image)="row">
          <b-img :src="row.value" width="75px" rounded alt="Image"></b-img>
        </template>
        <template v-slot:cell(created_at)="{ value, item }">
          <p class="mb-0">{{item.created_at_date_only}}</p>by
          <label class="font-weight-bold">{{item.created_by_username}}</label>
        </template>
        <template v-slot:cell(updated_at)="{ value, item }">
          <div v-if="item.updated_at_date_only == ''">-</div>
          <div v-else>
            <p class="mb-0">{{item.updated_at_date_only}}</p>by
            <label class="font-weight-bold">{{item.updated_by_username}}</label>
          </div>
        </template>
        <template v-slot:cell(action)="{ value, item }">
          <router-link
            :to="{name: 'editAboutus', params: {id: item.about_us_id}}"
            class="text-dark"
            v-b-tooltip.hover
            title="Edit"
          >
            <img src="@/assets/ic-edit.svg" class="mr-2" alt />
          </router-link>
          <b-link v-b-tooltip.hover title="Delete" class="text-dark" @click="del(item.about_us_id)">
            <img class="mr-2" src="@/assets/rectangle.svg" alt />
          </b-link>
          <b-link
            :class="{'order-link':item.order_field === 1}"
            @click="orderAbout({id:item.about_us_id,change:'up'})"
            class="text-primary"
            v-b-tooltip.hover
            title="Up Order"
          >
            <i class="fas fa-arrow-up mr-2"></i>
          </b-link>
          <b-link
            class="text-primary"
            :class="{'order-link':item.is_last_order}"
            @click="orderAbout({id:item.about_us_id,change:'down'})"
            v-b-tooltip.hover
            title="Down Order"
          >
            <i class="fas fa-arrow-down"></i>
          </b-link>
        </template>
      </b-table>
      <b-row class="mx-auto">
        <b-col md="4" class="mx-auto px-0">Total entries {{rows}}</b-col>
        <b-col md="4" class="mx-auto"></b-col>
        <b-col md="4" align="right" class="px-0">
          <b-pagination
            align="right"
            v-model="currentPage"
            :total-rows="rows"
            :per-page="perPage"
            class="my-0"
          ></b-pagination>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: true,
      errored: false,
      items: [],
      vuex: [],
      key: [
        {
          key: "created_at",
          label: "Created",
          sortable: true,
          class: "text-left w-10"
        },
        {
          key: "title.id",
          label: "Title",
          sortable: true,
          class: "text-center"
        },

        {
          key: "content.id",
          label: "Content",
          sortable: true,
          class: "text-center"
        },
        {
          key: "image",
          label: "Image",
          class: "text-center"
        },
        {
          key: "order_field",
          label: "Order Field",
          sortable: true,
          class: "text-left"
        },
        {
          key: "updated_at",
          label: "Updated",
          sortable: true,
          class: "text-left w-10"
        },
        { key: "action", label: "Action", class: "text-center w-10" }
      ],
      totalRows: 1,
      currentPage: 1,
      perPage: 10,
      pageOptions: [10, 25, 50, 100],
      sortBy: null,
      sortDesc: false,
      sortDirection: "asc",
      filter: null,
      customerShow: false,
      infoModal: {
        id: "info-modal",
        title: "",
        content: ""
      }
    };
  },
  computed: {
    sortOptions() {
      // Create an options list from our fields
      return this.fields
        .filter(f => f.sortable)
        .map(f => ({ text: f.label, value: f.key }));
    },
    rows() {
      return this.items.length;
    }
  },
  beforeCreate() {
    this.$store
      .dispatch("AboutusModule/getAbouts")
      .then(response => {
        this.loading = false;
      })
      .catch(error => {
        this.$swal({
          type: "error",
          title: "Oops...",
          text: error.response.data.message,
          showConfirmButton: false,
          timer: 1500
        });
        this.loading = false;
      });
  },
  created() {
    this.$store.watch(
      state => state.AboutusModule.about,
      (newValue, oldValue) => {
        this.items = newValue;
      }
    );
  },
  mounted() {
    // Set the initial number of items
    this.totalRows = this.items.length;
  },
  methods: {
    onFiltered(filteredItems) {
      // Trigger pagination to update the number of buttons/pages due to filtering
      this.totalRows = filteredItems.length;
      this.currentPage = 1;
    },
    orderAbout(order) {
      this.loading = true;
      const orderData = {
        change_type: order.change
      };
      this.$store
        .dispatch("AboutusModule/orderAbout", {
          id: order.id,
          orderData
        })
        .then(response => {
          this.$store
            .dispatch("AboutusModule/getAbouts")
            .then(response => {
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
            });
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          console.log(response);
        })
        .catch(error => {
          this.loading = false;
          this.$swal({
            type: "error",
            title: "Oops...",
            text: error.response.data.message,
            showConfirmButton: false,
            timer: 1500
          });
          console.log(error);
        });
    },
    del(id) {
      this.$swal({
        title: "Are you sure?",
        text: "You won't be able to revert this!",
        type: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes, delete it!"
      }).then(result => {
        if (result.value) {
          this.$store
            .dispatch("AboutusModule/getAbouts")
            .then(response => {
              this.loading = false;
            })
            .catch(error => {
              this.loading = false;
            });
          this.$swal({
            type: "success",
            title: "Your work has been saved",
            showConfirmButton: false,
            timer: 1500
          });
          this.$store.dispatch("AboutusModule/delAbout", id);
          this.$swal("Deleted!", "Your file has been deleted.", "success");
        }
      });
    }
  }
};
</script>

<style>
u {
  text-decoration: underline;
}
</style>
